import { render, staticRenderFns } from "./UserChoosejob.vue?vue&type=template&id=0b649719&scoped=true"
import script from "./UserChoosejob.vue?vue&type=script&lang=js"
export * from "./UserChoosejob.vue?vue&type=script&lang=js"
import style0 from "./UserChoosejob.vue?vue&type=style&index=0&id=0b649719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b649719",
  null
  
)

export default component.exports